class PnpGetData {
    constructor(){
        $pnp.setup({
            sp: {
                headers: {
                    "Accept": "application/json; odata=verbose"
                }
            }
        });
        this.idsListas = {
            TiposCuentasBancarias: {
                subsite: '/salud/transacciones/',
                name: 'TiposCuentasBancarias'
            },
            Bancos: {
                subsite: '/salud/transacciones/',
                name: 'Bancos'
            },
            TiposDocumento:{
                subsite: '/salud/',
                name: 'TiposDocumento'
            },
            IncapacidadesMotivos:{
                subsite: '/salud/transacciones/',
                name: 'IncapacidadesMotivos'
            },
            IncapacidadesMotivoDocumentos:{
                subsite: '/salud/transacciones/',
                name: 'IncapacidadesMotivoDocumentos'
            },
            Configuraciones: {
                subsite: '/salud/transacciones/',
                name: 'Configuraciones'
            }
        };    
    }

    getIdsListas() {
        return this.idsListas;
    }
    getInfobyList(listName, maxNumberOfElements, filter, columns, lookups, images) {
        var _this = this;
        return new Promise((resolve) => {
            var result = _this.getListItems(listName, maxNumberOfElements, encodeURI(filter), columns, lookups, images);
            result.then((items) => {
                
                var Sedes = [];
                
                Sedes.push(result);

                resolve(Sedes);
            });
        });
    };
    getListItems(listName, maxNumberOfElements, filter, columns, lookups, images) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var web = new $pnp.Web(window.location.origin + _this.idsListas[listName].subsite);
            var rows = web.lists.getByTitle(_this.idsListas[listName].name).items.top(maxNumberOfElements);
            var query = rows;
            if (filter)
                query = query.filter(filter);
            if (columns && columns.length > 0) {
                var fields = columns.join(',');
                if (lookups && lookups.length > 0) {
                    fields = fields + ',';
                    var lookupFields = new Array();
                    lookups.forEach(element => {
                        lookupFields.push(element.split('/')[0]);
                    });
                    fields = fields + lookups.join(',');
                    query = query.expand(lookupFields.join(','))
                }
                query = query.select(fields);
            }

            query.get().then(
                function (items) {
                    if (images && images.length > 0) {
                        var promises = [];
                        for (let i = 0; i < items.length; i++) {

                            var getRelatedImage = (htmlValues) => new Promise((resolve) => {
                                htmlValues.select(images.join(',')).get().then(htmlValue => {
                                    // extend our item and push into the result set
                                    var item = $pnp.Util.extend(items[i], {
                                        PublishingImage: htmlValue.CSImagenLogoImage
                                    });

                                    resolve(item);
                                });
                            });

                            const htmlValues = new $pnp.Item(rows.getById(items[i].Id), "FieldValuesAsHtml");
                            promises.push(getRelatedImage(htmlValues));
                        }

                        Promise.all(promises).then((results) => {
                            resolve(results);
                        });
                    }
                    else {
                        resolve(items);
                    }
                }
            ).catch(
                function (e) {
                    console.error(e);
                    reject(e);
                }
            );
        });
    }
}

export default PnpGetData